import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import WarningIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/WarningIcon'
import ErrorIcon from '~/pages/Farmer/ClimateCheck/AnswerClimateCheck/Steps/ErrorIcon'

const DieselPerCattle: React.FC = () => {
  const { control, clearErrors, setError } = useFormContext()

  const watchDieselConsumption = useWatch({ control, name: 'youngCattleDieselConsumption' })
  const watchCattleNumber = useWatch({ control, name: 'youngCattleNumber' })

  const dieselConsPerCowPerYear = useMemo(() => {

    if (watchDieselConsumption && watchCattleNumber) {
      const dieselConsumption = Math.floor(parseFloat(watchDieselConsumption?.toString()?.replace(',', '.')) / watchCattleNumber)
      if (dieselConsumption < 10 || dieselConsumption > 100) {
        setError('dieselCattleConsumption', { message: 'Der Dieselverbrauch pro Färse und Jahr muss mind. 10 Liter und darf max. 100 Liter betragen.' })
      } else {
        clearErrors('dieselCattleConsumption')
      }
      return dieselConsumption
    }

    return 0
  }, [watchCattleNumber, watchDieselConsumption])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>{'Liter pro Färse u. Jahr'}</div>
        {(dieselConsPerCowPerYear < 10 || dieselConsPerCowPerYear > 50) && <WarningIcon
          control={control}
          name='dieselCattleConsumption'
          content={'Der Dieselverbrauch pro Färse und Jahr muss mind. 10 Liter und darf max. 50 Liter betragen.'}
        />}
        <ErrorIcon
          control={control}
          name={'dieselCattleConsumption'}
        />
      </label>
      <div>{`${dieselConsPerCowPerYear} Liter pro Färse u. Jahr`}</div>
    </MilkProductionField>
  </Form.Field>
}
export default DieselPerCattle